import Controller from './init/Controller';

jQuery(document).ready(function() {
    Controller.init();
});

window.onload = () => {
    Controller.loaded();
};
window.onresize = () => {
    Controller.resized();
};
jQuery(window).on('scroll', () => {
    Controller.scrolled();
});
